module.exports = __webpack_public_path__ + "static/media/hpm-image-v3.5636288a.jpeg";